export const environment = {
  production: false,
  baseUrl: 'https://api.lc.dev.procesa.com.py/v1/',
  urlValidacionToken: 'https://api.web.develop.procesa.com.py/v1/',
  urlApiNegofin: 'https://api.negofin.develop.procesa.com.py/v1/',
  loginUrl: 'https://sistema.develop.procesa.com.py',
};
